// extracted by mini-css-extract-plugin
export default {"advertDetailService__label":"c-p_fX","advertDetailService__price":"c-p_fY"};